import { render, staticRenderFns } from "./MenuScroller.vue?vue&type=template&id=6f87c0ad&"
var script = {}
import style0 from "./MenuScroller.vue?vue&type=style&index=0&id=6f87c0ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports